type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig

export const login = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/login',
    method: 'POST',
    data: {
      username: action.payload.username,
      password: action.payload.password
    }
  }
}

export const forgotPassword = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/forgot-password',
    method: 'POST',
    data: {
      username: action.payload.username
    }
  }
}

export const resetPassword = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/reset-password',
    method: 'POST',
    data: {
      password: action.payload.password,
      resetToken: action.payload.resetToken
    }
  }
}

export const signup = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/signup',
    method: 'POST',
    data: {
      username: action.payload.username,
      email: action.payload.email,
      password: action.payload.password,
      inviteToken: action.payload.inviteToken
    }
  }
}

export const logout = (_action: ApiAction): ApiRequestConfig => {
  return {
    url: '/logout',
    method: 'POST'
  }
}

export const me = (_action: ApiAction): ApiRequestConfig => {
  return {
    url: '/me'
  }
}
